<template>
  <v-container fluid>
    <v-row v-if="!loading">
      <Address v-if="state === 'ADDRESS'" v-bind:location-change-callback="locationChange" ref="addressComponentRef" />
      <WasteType v-if="state === 'WASTE_TYPE'" v-bind:waste-types="wasteTypes" v-bind:proceed="wasteTypeChange" v-bind:goBack="backStep"/>
      <ServiceType v-if="state === 'SERVICE_TYPE'" v-bind:vehicles="serviceTypes" v-bind:proceed="serviceTypeChange" v-bind:goBack="backStep"/>
      <ContactDetails v-if="state === 'CONTACT_DETAILS'"
                      v-bind:waste-type="selectedWasteType"
                      v-bind:vehicle="selectedVehicle"
                      v-bind:captured-address="capturedAddress"
                      v-bind:service-provider-id="serviceProviderId"
                      v-bind:location="location"
                      v-bind:postCode="postCode"
                      v-bind:nextStep="nextStep"
                      v-bind:goBack="backStep"
        />
        <ConfirmInfo v-if="state === 'CONFIRM'"
                      v-bind:goBack="backStep"
                      v-bind:waste-type="selectedWasteType"
                      v-bind:vehicle="selectedVehicle"
                      v-bind:captured-address="capturedAddress"
        />
    </v-row>

    <v-row v-if="loading">
      <v-col cols="3" align="center">
        <Loading/>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import Address from '@/components/fast-quote/Address';
import WasteType from '@/components/fast-quote/WasteType';
import ServiceType from '@/components/fast-quote/ServiceType';
import ConfirmInfo from '@/components/fast-quote/ConfirmInfo';
import ContactDetails from '@/components/fast-quote/ContactDetails';
import Loading from '@/components/Loading';

const FAST_QUOTE_STATE = ['ADDRESS','WASTE_TYPE','SERVICE_TYPE', 'CONTACT_DETAILS', 'CONFIRM'];

export default {
  name: "FastQuote",
  components: { Loading, ConfirmInfo, ContactDetails, ServiceType, WasteType, Address },
  data () {
    return {
      loading: false,
      user: Object,
      location: {},
      postCode: '',
      capturedAddress: '',
      step: 0,
      state: FAST_QUOTE_STATE[0],
      selectedVehicle: {},
      selectedWasteType: {},
      serviceTypes: [],
      serviceProviderId: ''
    }
  },
  methods: {
    backStep(){
      this.step--;
      this.state = FAST_QUOTE_STATE[this.step];
    },
    focusAddressInput() {
      this.$refs.addressComponentRef.focusInput();
    },
    nextStep(){
      this.step++;
      this.state = FAST_QUOTE_STATE[this.step];
      if(this.step > 0){
        this.$emit('showInfo', true);
      }
      if(this.step == 4){
        this.$emit('step4', true);
      }
    },
    async locationChange(to, ad, code) {
      this.capturedAddress = ad;
      this.location = to;
      this.postCode = code;
      if (this.location.postal_code != null || this.postCode != ''){
        this.loading = true;
        await this.getWasteTypesForArea();
      }
    },
    wasteTypeChange(wasteType) {
      this.selectedWasteType = wasteType;
      let vehicleTypes = wasteType.vehicles;
      let vehicleSequence = [
        "2 Ton/ 2 Cube Skip",
        "Best Value! 4 Ton/ 3 Cube Skip",
        "10 Ton/ 11 Cube Skip",
        "8 Ton/ 6 Cube Flat Bin",
        "8 Ton/ 6 Cube V-Bin",
        "10 Ton/ 8 Cube Roro",
        "10 Ton/ 10 Cube Roro",
        "10 Ton/ 15 Cube Roro",
        "10 Ton/ 30 Cube Roro",
        "4 Ton/ 5 Cube Vault",
        "1 Ton Bakkie + Loader",
        "1.3 Ton Truck + Loader",
        "8 Ton/ 6 Cube Truck + Loader",
        "10 Ton/ 15 Cube Truck + Loader",
        "10 Ton/ 10 Cube Truck",
        "10 Ton/ 8 Cube Truck"
      ];
      let newVehicleSequence = [];

      // sort out vehicles array according to vehicleOrderSequence
      if(vehicleTypes && vehicleTypes.length > 0){
        for(let i = 0; i < vehicleSequence.length; i++){
          let vehicleName = vehicleSequence[i].toLowerCase();
          let foundVehicle = vehicleTypes.find(vehicle => vehicle.name.trim().toLowerCase() == vehicleName);
          if(foundVehicle){
            newVehicleSequence.push(foundVehicle);
          }
        }
      }
      this.serviceTypes = newVehicleSequence;
      this.nextStep();
    },
    serviceTypeChange(serviceType) {
      this.selectedVehicle = serviceType;
      this.nextStep();
    },
    async getWasteTypesForArea() {
      const postalCode = this.location.postal_code ? Number.parseInt(this.location.postal_code.slice(0,4)) : Number.parseInt(this.postCode);
      await this.$store.dispatch('fetchWasteTypesByArea', postalCode);
    }
  },
  computed: {
    vehicles() {
      return this.$store.getters.getVehicles;
    },
    wasteTypes() {
      let wastes = this.$store.getters.getWasteTypes;
      let wasteOrderSequence = [
        "General Waste",
        "Clean Building Rubble",
        "Mixed Building Rubble",
        "Plate Glass",
        "Garden Refuse",
        "Harvest Skip",
        "Special Waste",
        "Recyclables",
        "Best Deal! 6 Cube (3 Cube Rubble + 3 Cube General Waste)",
        "Best Deal! 6 Cube General Waste (2 x 3 Cube)",
        "Vault Delivery + Collection",
        "Recyclable Paper",
        "Cardboard - R200 Recycling Rebate Included",
        "Cardboard - Recyclables",
        "Cans - R200 Recycling Rebate Included",
        "Plastic - R200 Recycling Rebate Included"
      ];
      let newWasteOrderSequence = [];

      // sort out wastes array according to wasteOrderSequence
      if (wastes && wastes.length > 0) {
        for (let i = 0; i < wasteOrderSequence.length; i++) {
          let wasteName = wasteOrderSequence[i].toLowerCase();
          let foundWaste = wastes.find(waste => waste.name.trim().toLowerCase() == wasteName);
          if (foundWaste) {
            newWasteOrderSequence.push(foundWaste);
          }
        }
      }
      return newWasteOrderSequence;
    },
    areas(){
      return this.$store.getters.getAreas;
    },
    waste() {
      return this.$store.getters.getWaste;
    },
  },
  watch: {
    wasteTypes() {
      this.nextStep();
      this.loading = false;
    }
  },
  mounted(){
    this.$store.dispatch('fetchAreas');
  }
}
</script>
